import { render, staticRenderFns } from "./CarrinhoEmpresaAgrupamentoItemEditar.vue?vue&type=template&id=3bda69eb"
import script from "./CarrinhoEmpresaAgrupamentoItemEditar.vue?vue&type=script&lang=js"
export * from "./CarrinhoEmpresaAgrupamentoItemEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports